import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import HTMLReactParser from "html-react-parser";
import dateFormat from "dateformat";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Loader from "../../../Loader/Loader";
const GiftDetails = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`https://api.wlfmobile.com/api/user/gift/view/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data?.data);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <>
        <Loader></Loader>
      </>
    );
  } else {
    return (
      <>
        <div className="mobile-news-details-section news-details-area">
          <div className="container">
            <div className="news-details">
              <div className="news-details-title text-end">
                <Link to="/user/gift">View all gift</Link>
              </div>

              <main>
                <div className="news-details-main ">
                  <LazyLoadImage
                    alt="img"
                    effect="blur"
                    className=""
                    src={`https://api.wlfmobile.com/${data?.image}`}
                  />
                  <div className="news-title text-center">
                    <h5 className="pb-3">{data?.title}</h5>
                  </div>
                  <div className="news-details-time">
                    <span>{dateFormat(data.createdAt, "d/m/yyyy")}</span>
                  </div>
                  <div className="news-detail-all">
                    <p className="mb-2 news-detail-short_dis py-3">
                      {data?.short_dis}
                    </p>
                    {data?.dis ? HTMLReactParser(data?.dis) : ""}
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default GiftDetails;
